import { ProductAccountingDimensionsDto } from './dimensions.dto';

export class ProductAccountingDto {
  dimensions: ProductAccountingDimensionsDto;
  id?: string;

  constructor(d?: ProductAccountingDto) {
    if (d) {
      Object.assign(this, d);
    }
  }
}
